import { render } from "./specimenBasicInfos.vue?vue&type=template&id=3aef1de0"
import script from "./specimenBasicInfos.vue?vue&type=script&lang=js"
export * from "./specimenBasicInfos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__